<div class="container">
  <div class="container isDesktop">
    <div class="ratings">
      <div class="row">
        <div class="col-md-12 p-0">
          <p class="text-top-image">CHỌN VIETSTAR EXPRESS - CHỌN DỊCH VỤ 5 <img
              class="icon-star-top-image mb-display-none" src="assets/App_Themes/images/icon/star.png">
            <img class="icon-star-top-image d-block d-sm-none" src="assets/App_Themes/images/icon/star-mobile.png">
          </p>

          <p class="text-override-image">
            <span class="span-tex-override-image">150 bưu cục toàn quốc</span> <br class="d-block d-sm-none">
            <span class="span-tex-override-image">>500 phương tiện vận tải</span> <br class="d-block d-sm-none">
            <span class="span-tex-override-image">1500 nhân viên</span> <br class="d-block d-sm-none">
            <span style="padding-left: 12px;">5 tấn tải bay/ngày</span>
          </p>
          <img class="mb-display-none" width="785px" src="assets/App_Themes/images/bottom-banner.png">
          <img class="d-block d-sm-none" width="80%" height="114px"
            src="assets/App_Themes/images/bottom-banner-mobile.png">
        </div>
      </div>
    </div>
  </div>

</div>